angular.module('logbook')
.directive('logProvisioning', ['$http', '$filter', function($http, $filter) {
   return {
      restrict: 'E',

      scope: {
         'selectedLog': '=',
         'provisioningData': '='
      },

	  template: require('./log-provisioning.html'),

      link: function(scope, elem, attrs) {
         scope.products = [];
         scope.newInstance = {};
         scope.selectedProduct = 'undefined';
         scope.messages = {};
         
         Object.keys(scope.provisioningData).forEach(function(data) {
            if( !scope.provisioningData[data]['paymentKey']
              || scope.selectedLog.millisToFeatureExpiration[scope.provisioningData[data]['paymentKey']] > 0)
               scope.products.push(data);
         });

         scope.updateConfigs = function() {
            $http.get('/api/logConfigs', {
               params: {
                  'log': scope.selectedLog.id,
                  'hierarchy': 'logbook.provision',
                  'size': 10000
               }}).then(function(results) {
                  scope.instances = results.data._embedded.logConfigs;
                  scope.instanceNames = {};
                  scope.instances.forEach(function(instance) {
                     try {
                        if( instance.key.indexOf(".instance.") >= 0 )
                           scope.instanceNames[instance._links.self.href] = scope.getNameFromKey(instance.key, true);
                     }catch(e){
                     }
                  });
                  scope.$broadcast('updateConfigs');
                  delete scope.editingInstance;
               });
         };
         
         scope.getNameFromKey = function(key)
         {
            return key.substring(key.indexOf('.instance.') + '.instance.'.length);
         };

         scope.deleteInstance = function(instance)
         {
            $http.delete(instance._links.self.href).then(function() {
               scope.instances.splice(scope.instances.indexOf(instance), 1);
            });
         };
         
         scope.editInstance = function(instance)
         {
            var data = scope.provisioningData[scope.selectedProduct]['instance-form-' + scope.selectedType];
            Object.keys(scope.provisioningTypes).forEach(function(type) {
               var typeInstances = [];
               $filter('filter')( 
                  scope.instances, {"key": scope.selectedProduct + ".instance."+type+"."})
                  .forEach(function(typeInstance) {
                     var name = scope.getNameFromKey(typeInstance.key);
                     name = name.substring(name.indexOf('.')+1);
                     typeInstances.push({
                        "name":name,
                        "value": typeInstance._links.self.href
                     });
                  });
               data = data.replace('$$LOGBOOK_OPTIONS_' + type, JSON.stringify(typeInstances));
            });
            scope.instanceFields = JSON.parse(data);
            scope.editingInstanceModel = {};
            try {
               scope.editingInstanceModel = JSON.parse(instance.value);
            }catch(e) {
               console.log(e);
            }
            scope.editingInstance = instance;
         };
         
         scope.cancelEditing = function()
         {
            delete scope.instanceFields;
            delete scope.editingInstanceModel;
            delete scope.editingInstance;
         };
         
         scope.submit = function(instance)
         {
            var update = {};
            var nameFields = scope.provisioningData[scope.selectedProduct]['name-fields-'+scope.selectedType].split(',');
            scope.editingInstanceModel['log'] = scope.selectedLog._links.self.href;
            update['value'] = JSON.stringify(scope.editingInstanceModel);
            update['key'] = scope.selectedProduct + '.instance.' + scope.selectedType + '.';
            for( var i=0; i < nameFields.length; i++ )
            {
               if( nameFields[i].indexOf('.') > 0 )
               {
                  var linkedHref = scope.editingInstanceModel[nameFields[i].substring(0,nameFields[i].indexOf('.'))];
                  scope.instances.forEach(function(i) {
                     if( i._links.self.href == linkedHref )
                     {
                        var name = scope.getNameFromKey(i.key);
                        name = name.substring(name.indexOf('.')+1);
                        update['key'] += name;
                     }
                  });
               }
               else
                  update['key'] += scope.editingInstanceModel[nameFields[i]];
               update['key'] += (i == nameFields.length - 1 ? '' : ' - ');
            }
            if( instance._links )
            {
               return $http.patch(instance._links.self.href, update).then(scope.updateConfigs);
            }
            else
            {
               update['log'] = scope.selectedLog._links.self.href;
               update['hierarchy'] = 'logbook.provision';
               update['provision'] = true;
               update['dataType'] = '/api/dataTypes/3';
               return $http.post('/api/logConfigs', update)
                  .then(function(result) {
                     scope.updateConfigs();
                     scope.cancelEditing();
                     scope.showProvisionCode(result);
                  });
            }
         };

         scope.showProvisionCode = function(result)
         {
            scope.messages[result.data._links.self.href] =
               'Provision Code (valid for 5 minutes): ' + result.data.provisionCode;
         };
         
         scope.reprovision = function(instance)
         {
            return $http.patch(instance._links.self.href, {'provision':true}).then(function(result) {
               scope.showProvisionCode(result);
            });
         };

         scope.updateConfigs();

         scope.setSelectedType = function(selectedType) {
            scope.selectedType = selectedType;
         };
         
         scope.productUpdated = function()
         {
            scope.provisioningTypes = {};
            Object.keys(scope.provisioningData).forEach(function(key) {
               if( scope.selectedProduct == key) {
                  Object.keys(scope.provisioningData[key]).forEach(function(dataKey) {
                     if( dataKey.indexOf('instance-form-') == 0 )
                        scope.provisioningTypes[dataKey.substring('instance-form-'.length)]
                            = scope.provisioningData[key][dataKey];
                  });
               }
            });
         };

         if (scope.products.length === 1) { // If there is only one product, set it as default.
             scope.selectedProduct = scope.products[0];
             scope.productUpdated();
         }
      }
    };
  }])